<!-- <app-sign-in></app-sign-in> -->
<router-outlet />
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.95)" size = "medium" color = "#fff"   [fullScreen] = "true"><p style="color: white" > Loading... </p>
</ngx-spinner>
<app-notification></app-notification>